import { isFragmentationMode } from "./isFragmentationMode";

import { FRAGMENT_BOUNDARY_TOKEN } from "@asosteam/asos-web-template-fragmentation/constants";

const FRAGMENT_BOUNDARY_TOKEN_COMMENT = `<!--${FRAGMENT_BOUNDARY_TOKEN}%-->`;

export const fragmentBoundaryToken = isFragmentationMode
  ? FRAGMENT_BOUNDARY_TOKEN_COMMENT
  : "";
